import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/Service/Common.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-dci-status-summary-report',
  templateUrl: './dci-status-summary-report.component.html',
  styleUrls: ['./dci-status-summary-report.component.css']
})
export class DCIStatusSummaryReportComponent implements OnInit {
  public reportServer!: string;
  public reportUrl!: string;
  public showParameters!: string;
  public parameters: any;
  public language!: string;
  public height!: number;
  public width!: number;
  public toolbar!: string;

  constructor(private commonService: CommonService,) { }

  ngOnInit() {
    this.EmbedSSRSReport();
  }
  public EmbedSSRSReport() {
    this.reportServer = environment.reportHost + "EIP40Reports/EIP4EDMS/EDMS/DCIStatusSummary";
    this.reportUrl = environment.reportHost + "EIP40Reports/EIP4EDMS/EDMS/DCIStatusSummary";
    this.showParameters = "false";
    this.parameters = {
      "Project_Id": this.commonService.getProjectId(),
      "Group_Id":  this.commonService.getLoggedInUserGroupId(),
      
    };
    this.language = "en-us";
    this.width = 1000;
    this.height = 620;
    this.toolbar = "true";
  }
}
